let debounceTimeout: NodeJS.Timeout | undefined;

function debounce(
  callback: (...args: any) => void,
  timeout: number,
): typeof callback {
  return (...args: any) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
      debounceTimeout = undefined;
    }

    debounceTimeout = setTimeout(() => {
      callback(...args);
      debounceTimeout = undefined;
    }, timeout);
  };
}

export default debounce;
